import React from 'react';
import { Lock, Users } from 'lucide-react';

export const passtSicht = (m, filter) => filter === 'alle' || (filter === 'vertraulich' ? !!m.vertraulich_fuer : m.vertraulich_fuer === filter);

export const VertraulichFilter = ({ beteiligte, value, onChange }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid="vertraulich-filter" title="Nachrichten filtern"
    className="h-6 bg-white border border-gray-200 rounded-full px-2 text-[10px] tracking-wider text-[#1B3A5C] focus:outline-none focus:border-[#b8893d]">
    <option value="alle">ALLE NACHRICHTEN</option>
    <option value="vertraulich">NUR VERTRAULICHE</option>
    {beteiligte.map((b) => <option key={b.mandanten_nr} value={b.mandanten_nr}>VERTRAULICH · {b.name}</option>)}
  </select>
);

export const VertraulichComposer = ({ isTeam, beteiligte, value, onChange }) => {
  const aktiv = !!value;
  if (!isTeam) {
    return (
      <button type="button" onClick={() => onChange(aktiv ? '' : '1')} aria-pressed={aktiv} data-testid="vertraulich-toggle"
        className={`inline-flex items-center gap-1.5 mb-2 px-2.5 py-1 rounded-full border text-[11px] transition-colors duration-200 ${aktiv ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'bg-white text-[#34536b] border-gray-200 hover:border-[#b8893d]'}`}>
        {aktiv ? <Lock className="w-3 h-3 text-[#e0b56a]" /> : <Users className="w-3 h-3" />}
        {aktiv ? 'Vertraulich an die Kanzlei, die anderen Beteiligten lesen nicht mit' : 'Sichtbar für alle Beteiligten der Akte · vertraulich schreiben'}
      </button>
    );
  }
  return (
    <div className="flex items-center gap-2 mb-2 min-w-0 text-[11px] text-[#34536b]" data-testid="vertraulich-composer">
      {aktiv ? <Lock className="w-3.5 h-3.5 text-[#b8893d]" /> : <Users className="w-3.5 h-3.5" />}
      <span className="tracking-wider shrink-0">SICHTBAR FÜR:</span>
      <select value={value} onChange={(e) => onChange(e.target.value)} data-testid="vertraulich-empfaenger"
        className={`min-w-0 flex-1 max-w-full truncate border px-2 py-1 text-[11px] rounded-sm focus:outline-none focus:border-[#b8893d] ${aktiv ? 'bg-[#1B3A5C] text-white border-[#1B3A5C]' : 'bg-[#f5f8fa] border-gray-200 text-[#1B3A5C]'}`}>
        <option value="">Alle Beteiligten der Akte</option>
        {beteiligte.map((b) => <option key={b.mandanten_nr} value={b.mandanten_nr}>Vertraulich: nur {b.name} ({b.rolle})</option>)}
      </select>
    </div>
  );
};

export const VertraulichBadge = ({ item, isTeam, mine }) => (
  <span className={`inline-flex items-center gap-1 text-[9.5px] tracking-wider uppercase px-1.5 py-0.5 rounded-sm mb-1 mr-1 ${mine ? 'bg-white/15 text-[#e0b56a]' : 'bg-[#1B3A5C] text-[#e0b56a]'}`}
    data-testid={`msg-vertraulich-${item.id}`} title="Nur für diesen Mandanten und die Kanzlei sichtbar">
    <Lock className="w-2.5 h-2.5" /> {isTeam ? `Vertraulich · nur ${item.vertraulich_name || item.vertraulich_fuer}` : 'Vertraulich · nur Sie und die Kanzlei'}
  </span>
);
